import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { clearAuthToken } from "./authSlice";
import axios from "axios";

export const getProfile = createAsyncThunk(
  "profile/getProfile",
  async ({ token }, { rejectWithValue, dispatch }) => {
    try {
      const response = await axios.get(`/api/account/profile`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      dispatch(clearAuthToken());
      return rejectWithValue(error.response.data);
    }
  }
);

const profileSlice = createSlice({
  name: "profile",
  initialState: {
    user: null,
    loading: false,
    error: false,
    workouts: [],
    workoutTemplates: [],
  },
  reducers: {
    createDailyTodo: (state, action) => {
      console.log("Creating daily todo", action.payload);
    },
    updateDailyTodo: (state, action) => {
      console.log("Updating daily todo", action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        const { user, workouts, workoutTemplates, admin } = action.payload;
        state.user = user;
        state.admin = admin;
        state.loading = false;
        state.workouts = workouts;
        state.workoutTemplates = workoutTemplates;
      })
      .addCase(getProfile.rejected, (state, action) => {
        state.error = true;
        state.loading = false;
      });
  },
});

export const { createDailyTodo, updateDailyTodo } = profileSlice.actions;

export default profileSlice;
